import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { media } from "@atlaskit/primitives";

import { useAccountCreationContext } from "@/components/signup/account-creation";
import { Button } from "@/libraries/design/components";

export const InlineSubmit = () => {
    const intl = useIntl();
    const { isSubmitting, hasSubmitted, formError, onClickSubmitButton } =
        useAccountCreationContext();

    const buttonText = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.submit",
        defaultMessage: "Sign up"
    });

    return (
        <Button
            css={buttonCss}
            type="submit"
            disabled={isSubmitting || (hasSubmitted && !formError)}
            onClick={onClickSubmitButton}
            data-testid="embedded-signup-submit"
        >
            {buttonText}
        </Button>
    );
};

const buttonCss = css({
    fontFamily: "inherit",
    height: "48px",
    padding: "12px 24px !important",
    whiteSpace: "nowrap",
    flexShrink: 0,
    flexGrow: 0,
    fontWeight: 400,
    [media.above.sm]: {
        margin: "-1px -1px -1px 0"
    },
    [media.below.sm]: {
        width: "100%",
        maxWidth: "100%"
    }
});
